export default __webpack_public_path__ + "static/media/arrow-right.48065565.svg";